import { render } from "./StockPopup.vue?vue&type=template&id=1d870fa1&scoped=true"
import script from "./StockPopup.vue?vue&type=script&lang=js"
export * from "./StockPopup.vue?vue&type=script&lang=js"

import "./StockPopup.vue?vue&type=style&index=0&id=1d870fa1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d870fa1"]])

export default __exports__